exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".from[data-v-493d5a7c]{padding:0 24px;margin-top:20px}[data-v-493d5a7c] .el-date-editor{width:100%}[data-v-493d5a7c] .el-textarea__inner{resize:none;border:1px solid #dcdfe6 !important}[data-v-493d5a7c] .el-input-number--medium{width:100%}[data-v-493d5a7c] .el-select--medium{width:100%}[data-v-493d5a7c] .el-form-item:last-of-type{margin-bottom:0}.dialog-footer[data-v-493d5a7c]{padding-top:20px;text-align:right}\n", ""]);

// exports
